export default __webpack_public_path__ + "static/media/aaa.1e33211d.png";